import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-481e3f6a")

_pushScopeId("data-v-481e3f6a")
const _hoisted_1 = { class: "fridgepushsettings-page" }
const _hoisted_2 = {
  key: 0,
  class: "fridgepushsettings-page-content"
}
const _hoisted_3 = { class: "fridgepushsettings-page-content-content" }
const _hoisted_4 = { class: "fridgepushsettings-page-content-content-switch" }
const _hoisted_5 = { class: "fridgepushsettings-page-content-content-switch-description" }
const _hoisted_6 = { class: "fridgepushsettings-page-content-content-switch-description-title" }
const _hoisted_7 = { class: "fridgepushsettings-page-content-content-switch-description-title-text" }
const _hoisted_8 = { class: "fridgepushsettings-page-content-content-switch-description-description" }
const _hoisted_9 = { class: "fridgepushsettings-page-content-content-switch-description-description-text" }
const _hoisted_10 = {
  key: 0,
  class: "fridgepushsettings-page-content-content-switch"
}
const _hoisted_11 = { class: "fridgepushsettings-page-content-content-switch-description" }
const _hoisted_12 = { class: "fridgepushsettings-page-content-content-switch-description-title" }
const _hoisted_13 = { class: "fridgepushsettings-page-content-content-switch-description-title-text" }
const _hoisted_14 = { class: "fridgepushsettings-page-content-content-switch-description-description" }
const _hoisted_15 = { class: "fridgepushsettings-page-content-content-switch-description-description-text" }
const _hoisted_16 = { class: "fridgepushsettings-page-content-content-switch" }
const _hoisted_17 = { class: "fridgepushsettings-page-content-content-switch-description" }
const _hoisted_18 = { class: "fridgepushsettings-page-content-content-switch-description-title" }
const _hoisted_19 = { class: "fridgepushsettings-page-content-content-switch-description-title-text" }
const _hoisted_20 = { class: "fridgepushsettings-page-content-content-switch-description-description" }
const _hoisted_21 = { class: "fridgepushsettings-page-content-content-switch-description-description-text" }
const _hoisted_22 = { class: "fridgepushsettings-page-content-content-switch" }
const _hoisted_23 = { class: "fridgepushsettings-page-content-content-switch-description" }
const _hoisted_24 = { class: "fridgepushsettings-page-content-content-switch-description-title" }
const _hoisted_25 = { class: "fridgepushsettings-page-content-content-switch-description-title-text" }
const _hoisted_26 = { class: "fridgepushsettings-page-content-content-switch-description-description" }
const _hoisted_27 = { class: "fridgepushsettings-page-content-content-switch-description-description-text" }
const _hoisted_28 = {
  key: 1,
  class: "fridgepushsettings-page-content-content-doormonitor"
}
const _hoisted_29 = { class: "fridgepushsettings-page-content-content-switch fridgepushsettings-page-content-content-doormonitor-noseparator" }
const _hoisted_30 = { class: "fridgepushsettings-page-content-content-switch-description" }
const _hoisted_31 = { class: "fridgepushsettings-page-content-content-switch-description-title" }
const _hoisted_32 = { class: "fridgepushsettings-page-content-content-switch-description-title-text" }
const _hoisted_33 = { class: "fridgepushsettings-page-content-content-switch-description-description" }
const _hoisted_34 = { class: "fridgepushsettings-page-content-content-switch-description-description-text" }
const _hoisted_35 = {
  key: 0,
  class: "fridgepushsettings-page-content-content-doormonitor-time"
}
const _hoisted_36 = { class: "fridgepushsettings-page-content-content-doormonitor-time-time" }
const _hoisted_37 = { class: "fridgepushsettings-page-content-content-doormonitor-time-time-text" }
const _hoisted_38 = { class: "fridgepushsettings-page-content-content-doormonitor-time-button-text" }
const _hoisted_39 = {
  key: 2,
  class: "fridgepushsettings-page-content-content-switch"
}
const _hoisted_40 = { class: "fridgepushsettings-page-content-content-switch-description" }
const _hoisted_41 = { class: "fridgepushsettings-page-content-content-switch-description-title" }
const _hoisted_42 = { class: "fridgepushsettings-page-content-content-switch-description-title-text" }
const _hoisted_43 = { class: "fridgepushsettings-page-content-content-switch-description-description" }
const _hoisted_44 = { class: "fridgepushsettings-page-content-content-switch-description-description-text" }
const _hoisted_45 = { class: "fridgepushsettings-page-content-content-bottom" }
const _hoisted_46 = { class: "fridgepushsettings-page-content-content-bottom-text" }
const _hoisted_47 = { class: "fridgepushsettings-page-content-bottom" }
const _hoisted_48 = /*#__PURE__*/_createVNode("div", { class: "fridgepushsettings-page-content-bottom-top" }, null, -1)
const _hoisted_49 = { class: "fridgepushsettings-page-content-bottom-button" }
const _hoisted_50 = { class: "fridgepushsettings-page-content-bottom-button-button-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonSwitch = _resolveComponent("CommonSwitch")
  const _component_FridgeDetailsSelectHours = _resolveComponent("FridgeDetailsSelectHours")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")
  const _component_FridgeDetailsConfirmSettingsDialog = _resolveComponent("FridgeDetailsConfirmSettingsDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.isValidSettings)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, [
                  _createVNode("span", _hoisted_7, _toDisplayString(_ctx.errorOccuredText), 1)
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.errorOccuredDescriptionText), 1)
                ])
              ]),
              _createVNode(_component_CommonSwitch, {
                class: "fridgepushsettings-page-content-switch-switch",
                key: _ctx.updateDisplayKey,
                initialState: _ctx.errorOccuredStatus,
                onChangeState: _ctx.changeErrorOccured
              }, null, 8, ["initialState", "onChangeState"])
            ]),
            (_ctx.isValidCoolingAssist)
              ? (_openBlock(), _createBlock("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("span", _hoisted_13, _toDisplayString(_ctx.coolingAssistText), 1)
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode("span", _hoisted_15, _toDisplayString(_ctx.coolingAssistDescriptionText), 1)
                    ])
                  ]),
                  _createVNode(_component_CommonSwitch, {
                    class: "fridgepushsettings-page-content-switch-switch",
                    key: _ctx.updateDisplayKey,
                    initialState: _ctx.coolingAssistStatus,
                    onChangeState: _ctx.changeCoolingAssist
                  }, null, 8, ["initialState", "onChangeState"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode("div", _hoisted_18, [
                  _createVNode("span", _hoisted_19, _toDisplayString(_ctx.waterShortageText), 1)
                ]),
                _createVNode("div", _hoisted_20, [
                  _createVNode("span", _hoisted_21, _toDisplayString(_ctx.waterShortageDescriptionText), 1)
                ])
              ]),
              _createVNode(_component_CommonSwitch, {
                class: "fridgepushsettings-page-content-switch-switch",
                key: _ctx.updateDisplayKey,
                initialState: _ctx.waterShortageStatus,
                onChangeState: _ctx.changeWaterShortage
              }, null, 8, ["initialState", "onChangeState"])
            ]),
            _createVNode("div", _hoisted_22, [
              _createVNode("div", _hoisted_23, [
                _createVNode("div", _hoisted_24, [
                  _createVNode("span", _hoisted_25, _toDisplayString(_ctx.iceMakingCompletionText), 1)
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("span", _hoisted_27, _toDisplayString(_ctx.iceMakingCompletionDescriptionText), 1)
                ])
              ]),
              _createVNode(_component_CommonSwitch, {
                class: "fridgepushsettings-page-content-switch-switch",
                key: _ctx.updateDisplayKey,
                initialState: _ctx.iceMakingCompletionStatus,
                onChangeState: _ctx.changeIceMakingCompletion
              }, null, 8, ["initialState", "onChangeState"])
            ]),
            (_ctx.isValidDoorMonitor)
              ? (_openBlock(), _createBlock("div", _hoisted_28, [
                  _createVNode("div", _hoisted_29, [
                    _createVNode("div", _hoisted_30, [
                      _createVNode("div", _hoisted_31, [
                        _createVNode("span", _hoisted_32, _toDisplayString(_ctx.doorMonitorText), 1)
                      ]),
                      _createVNode("div", _hoisted_33, [
                        _createVNode("span", _hoisted_34, _toDisplayString(_ctx.doorMonitorDescriptionText), 1)
                      ])
                    ]),
                    _createVNode(_component_CommonSwitch, {
                      class: "fridgepushsettings-page-content-switch-switch",
                      key: _ctx.updateDisplayKey,
                      initialState: _ctx.doorMonitorStatus,
                      onChangeState: _ctx.changeDoorMonitor
                    }, null, 8, ["initialState", "onChangeState"])
                  ]),
                  (_ctx.isValidDoorMonitorTime)
                    ? (_openBlock(), _createBlock("div", _hoisted_35, [
                        _createVNode("div", _hoisted_36, [
                          _createVNode("span", _hoisted_37, _toDisplayString(_ctx.doorMonitorTimeText), 1)
                        ]),
                        _createVNode("div", {
                          class: "fridgepushsettings-page-content-content-doormonitor-time-button",
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickChangeTime(...args)))
                        }, [
                          _createVNode("span", _hoisted_38, _toDisplayString(_ctx.doorMonitorTimeButtonText), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.isValidPartialHalf)
              ? (_openBlock(), _createBlock("div", _hoisted_39, [
                  _createVNode("div", _hoisted_40, [
                    _createVNode("div", _hoisted_41, [
                      _createVNode("span", _hoisted_42, _toDisplayString(_ctx.partialHalfTitleText), 1)
                    ]),
                    _createVNode("div", _hoisted_43, [
                      _createVNode("span", _hoisted_44, _toDisplayString(_ctx.partialHalfDescriptionText), 1)
                    ])
                  ]),
                  _createVNode(_component_CommonSwitch, {
                    class: "fridgepushsettings-page-content-switch-switch",
                    key: _ctx.updateDisplayKey,
                    initialState: _ctx.partialHalfStatus,
                    onChangeState: _ctx.changePartialHalfValueCompletion
                  }, null, 8, ["initialState", "onChangeState"])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_45, [
              _createVNode("span", _hoisted_46, _toDisplayString(_ctx.bottomDescriptionText), 1)
            ])
          ]),
          _createVNode("div", _hoisted_47, [
            _hoisted_48,
            _createVNode("div", _hoisted_49, [
              _createVNode("div", {
                class: "fridgepushsettings-page-content-bottom-button-button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.sendButtonAction(...args)))
              }, [
                _createVNode("span", _hoisted_50, _toDisplayString(_ctx.sendButtonText), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_FridgeDetailsSelectHours, {
      key: _ctx.updateDisplayKey,
      isShowSelectHours: _ctx.isShowSelectHours,
      initialHour: _ctx.initialHour,
      minHour: _ctx.minHour,
      maxHour: _ctx.maxHour,
      onClickCancel: _ctx.cancelSelectHours,
      onClickComplete: _ctx.selectHours
    }, null, 8, ["isShowSelectHours", "initialHour", "minHour", "maxHour", "onClickCancel", "onClickComplete"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"]),
    _createVNode(_component_FridgeDetailsConfirmSettingsDialog, {
      isShowDialog: _ctx.isShowConfirm,
      displayTitle: _ctx.confirmDialogTitle,
      displayItemList: _ctx.confirmList,
      isInitial: false,
      onClickCancel: _ctx.cancelClick,
      onClickSend: _ctx.sendClick
    }, null, 8, ["isShowDialog", "displayTitle", "displayItemList", "onClickCancel", "onClickSend"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowDialog,
      dialogType: _ctx.dialogType,
      title: _ctx.dialogTitle,
      message: _ctx.dialogMessage,
      positiveLabel: _ctx.dialogPositiveButtonTitle,
      negativeLabel: _ctx.dialogNegativeButtonTitle,
      onPositiveClick: _ctx.dialogPositiveButtonHandler,
      onNegativeClick: _ctx.dialogNegativeButtonHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})